module.exports = __webpack_public_path__ + "img/jiaotong.8a53e7ce.png";